import axios from '@service'
import { SUBMIT_PROCESS_RESULT } from './api'
import { HTTP_ERR_SUCCESS } from '@constant/api_status'
import { ERROR_DEFAULT_HTTP_REQUEST_FAIL } from '@constant/error'

// 处理结果录入
export default async function submitProcessResultService(payload = {}, config = {}) {
    const param = {
        ...SUBMIT_PROCESS_RESULT,
        ...config,
        data: payload
    }

    const { data } = await axios(param)

    if (data.code === HTTP_ERR_SUCCESS) {
        return data.result || {}
    } else {
        throw new Error(data.errorMessage || ERROR_DEFAULT_HTTP_REQUEST_FAIL)
    }
}
